import {getAllControllHistory,getAllTimeControllHistory, getControlHistoryByTimeInterval, postControllHistory} from '../../../../api/eastCoastDataApi/scenicPlace/ControlHistoryApi'
import Utils from '../../../../utils/utils'
import CONST from '../../../../utils/const'

const state = {
  allControllHistory: [],
  allTimeControllHistory:[],
  controlHistoryByTimeInterval: [],
}

const getters = {
  getScenicControlData: (state) => (scenicAreaId = -1) => {
    const target = state.allControllHistory.filter(c => c.scenicAreaId === scenicAreaId)
    const controlStatus = Utils.mapReduceControlStatus(target) // scenicAreaId === -1 在mapReduceControlStatus已處理

    return controlStatus
  },

  getAllScenicControlData:(state) =>{
    const target = state.allControllHistory;
    // const controlStatus = Utils.mapReduceControlStatus(target);
    return target
  },

  getAllTimeScenicControlData:(state) =>{
    const target = state.allTimeControllHistory;
    // const controlStatus = Utils.mapReduceControlStatus(target);
    return target
  }

}

const actions = {
  async getAllControllHistory({commit}, condition ={}) {
    const result = await getAllControllHistory()

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('allControllHistory', result.data)
    }
  },

  async getAllTimeControllHistory({commit}, condition ={}) {
    const result = await getAllTimeControllHistory()

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('allTimeControllHistory', result.data)
    }
  },

  async getControlHistoryByTimeInterval({commit}, condition ={}) {
    const result = await getControlHistoryByTimeInterval(condition);

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('controlHistoryByTimeInterval', result.data)
    }
  },

  async postControllHistory({commit}, controlData ={}) {
    const result = await postControllHistory(controlData)

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('updateControlHistory', { data: result.data, mode: 'post' })
    }
  }
}

const mutations = {
  allControllHistory(state, data) {
    state.allControllHistory = data
  },

  allTimeControllHistory(state, data) {
    state.allTimeControllHistory = data
  },

  controlHistoryByTimeInterval(state, data) {
    state.controlHistoryByTimeInterval = data
  },

  updateControlHistory(state,  { data, mode }) {
    switch (mode) {
      case 'post':
        let targetIndex  = state.allControllHistory.findIndex(c => c.scenicAreaId === data.scenicAreaId && c.controlHistoryType === data.controlHistoryType)
        if (targetIndex === -1) {
          state.allControllHistory.push(data.result)
        } else {
          //要回傳新的 array 元素才會觸發 state 更新 
          // state.allControllHistory[targetIndex] = data;
          state.allControllHistory.splice(targetIndex, 1, data.result); 
        }
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}